import Regulation from "./Regulation";

export default Regulation;